import { render } from "./ExpenseBreakdownChart.vue?vue&type=template&id=5b15593e&ts=true"
import script from "./ExpenseBreakdownChart.vue?vue&type=script&lang=ts"
export * from "./ExpenseBreakdownChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__